/* globals elkitorg_config */

import {node_observable_component} from "common/util/ComponentDecorator";
import CurrencyUtil from "common/util/CurrencyUtil";
import './checkout-summary.scss';

@node_observable_component
export default class CheckoutSummary {
	static classname = 'checkout-summary';

	constructor($summary) {
		this.$summary = $summary;
		this.total = this.$summary.attr('data-total');
		this.bindGlobalEvents();
	}

	bindGlobalEvents() {
		$(document).on('update_rate@checkout-shipping-method check@checkout-shipping-method', '.checkout-shipping-method', (e, args) => {
			this.$summary.addClass('checkout-summary_has-shipping');
			this.updateTotal(args);
		});
	}

	updateTotal(args) {
		if (!args.rate) {
			return;
		}

		this.setShipping(args.rate.rate_raw, `Доставка — <span class="checkout-summary__shipping-name">${args.name} ${args.rate.name ? `(${args.rate.name})` : ''}</span>`);
		let rateRaw = args.rate.rate_raw;
		if (rateRaw === 'none') rateRaw = 0;
		this.setTotal(rateRaw + Number(this.total));
	}

	setShipping(shipping_cost, shipping_name) {
		const format_shipping = (shipping_cost === 0) ? 'Бесплатно' : (shipping_cost === 'none')  ? '' : CurrencyUtil.format(shipping_cost, elkitorg_config.currency_info[elkitorg_config.currency]);
		this.$summary.find('.checkout-summary__sub-total_shipping .row-value')
			.trigger('set_value:parent', {val: format_shipping})
			.trigger('set_label', {val: shipping_name});
	}

	setTotal(total) {
		const format_total = CurrencyUtil.format(total, elkitorg_config.currency_info[elkitorg_config.currency]);
		this.$summary.find('.checkout-summary__total').html(format_total);
	}

}
